import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {
  constructor() {}

  repositionModal(buttonSelector, modalDialog = '.modal-dialog') {
    setTimeout(() => {
      const modalDialogEl = document.querySelector(modalDialog);
      const btnEl = document.querySelector(buttonSelector);
      // new position should be client hight - scroll top + some padding if needed
      // only set if the modal is present
      // if the offset window is too high then do not reposition the modal
      const bodyRect = document.body.getBoundingClientRect();
      const elemRect = btnEl.getBoundingClientRect();
      const modalOffset = elemRect.top - bodyRect.top;
      const modalHeight = modalDialogEl.clientHeight;
      if (window.innerHeight > modalOffset) {
        modalDialogEl['style'].top = modalOffset - modalHeight + 'px';
      }
      modalDialogEl.scrollIntoView();
    }, 100);
  }
}
